export default __webpack_public_path__ + "static/media/1016.31b517ab.svg";